// components
import { Typography } from '@centria-ui-atoms/typography'

// prime components
import { Chips as PrChips } from 'primereact/chips'

// style
import classes from './styles.module.scss'

// types
import type { InputsEnum, variantsEnum } from '@centria-ui/commons/enums'
import type { ChipsProps as PrChipsProps } from 'primereact/chips'
import type { FC } from 'react'

export interface ChipsProps extends PrChipsProps {
  label?: string
  showInfo?: boolean
  infoLabel?: string
  inputVariant?: keyof typeof InputsEnum
  inputColor?: typeof variantsEnum.light | typeof variantsEnum.white
}

export const Chips: FC<ChipsProps> = ({
  label,
  infoLabel,
  className = '',
  showInfo = false,
  inputColor = 'light',
  inputVariant = 'block',
  ...props
}) => {
  return (
    <>
      {label && (
        <Typography fontSize='small' htmlFor={props.inputId}>
          {label}
        </Typography>
      )}
      <PrChips
        {...props}
        className={`${className} ${classes.chips} ${
          classes[`input_${inputVariant}`]
        } ${classes[`input_${inputColor}`]} `}
      />
      {showInfo && (
        <Typography fontSize='minimum' fontcolor='info' className='mt-2'>
          {infoLabel ??
            'Se agrega un nuevo valor cuando se presiona la tecla Intro o añades una coma'}
        </Typography>
      )}
    </>
  )
}
